class FlashMessageManager {
  _defaultFlashMessage = null

  register(_ref) {
    if (!this._defaultFlashMessage) {
      this._defaultFlashMessage = _ref
    }
  }

  unregister() {
    if (this._defaultFlashMessage) {
      this._defaultFlashMessage = null
    }
  }

  getDefault() {
    return this._defaultFlashMessage
  }
}

export default new FlashMessageManager()
